const formatUserPreferencesData = ({
  user,
  id,
  // language,
  language_id,
  dateformat,
  date_format_detail,
  numberformat,
  updatedUsername,
  otp_browser_dependent,
}) => {
  return {
    user,
    id,
    language: language_id,
    dateFormat: date_format_detail?.[`long_description_${language_id}`] ?? 'DD.MM.YYYY',
    dateFormatId: dateformat,
    numberFormat: numberformat,
    updatedUsername,
    otp_browser_dependent,
  };
};

export default formatUserPreferencesData;
